import { useDroppable } from "@dnd-kit/core";
import clsx from "clsx";
import { FC } from "react";

import styles from "./droppable.module.scss";

type Props = {
  id: string | number;
  index?: number;
};

const EmptyDroppableRow: FC<Props> = ({ id, index }: Props) => {
  const { isOver, setNodeRef } = useDroppable({
    id,
    data: {
      type: "EMPTY",
      index
    }
  });

  return (
    <section
      className={clsx(
        styles.empty_row,
        isOver && styles.drop_border,
        isOver && styles.empty_row_hover
      )}
      ref={setNodeRef}
    ></section>
  );
};

export default EmptyDroppableRow;
